import React, { useEffect, useRef, useState } from 'react';

/**
 * CustomCursor — subtle accent dot cursor for desktop.
 * Disabled on touch devices via CSS (cursor: auto).
 */
const CustomCursor = () => {
  const dotRef = useRef(null);
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    // Detect touch device — skip
    if (window.matchMedia('(hover: none)').matches) return;

    const dot = dotRef.current;
    if (!dot) return;

    let rafId;
    let mouseX = -100;
    let mouseY = -100;

    const onMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const onMouseOver = (e) => {
      const target = e.target;
      const isInteractive =
        target.closest('a') ||
        target.closest('button') ||
        target.closest('[role="button"]') ||
        target.closest('.project-card') ||
        target.closest('.cmd-input') ||
        target.closest('.autocomplete-item');
      setHovering(!!isInteractive);
    };

    const tick = () => {
      if (dot) {
        dot.style.left = mouseX + 'px';
        dot.style.top  = mouseY + 'px';
      }
      rafId = requestAnimationFrame(tick);
    };

    window.addEventListener('mousemove', onMouseMove, { passive: true });
    window.addEventListener('mouseover', onMouseOver, { passive: true });
    rafId = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseover', onMouseOver);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      ref={dotRef}
      className={`cursor-dot${hovering ? ' hovering' : ''}`}
      aria-hidden="true"
    />
  );
};

export default CustomCursor;
